import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import moment from 'moment';

import Button from 'components/Button';
import InfoBar from 'components/InfoBar';

import ReferralFormProviderList from './ReferralFormProviderList';
import ReferralFormField from './ReferralFormField';
import ReferralFormTextarea from './ReferralFormTextarea';
import ReferralFormSelect from './ReferralFormSelect';
import ReferralFormRadioGroup from './ReferralFormRadioGroup';
import ReferralFormCheckboxGroup from './ReferralFormCheckboxGroup';
import ReferralFormDatepicker from './ReferralFormDatepicker';

import { ReferralProvider, ReferralLocationShape, ReferralSchoolShape, ReferralLanguageShape } from 'entities';
import * as actions from 'actions';
import { getF2F, getInfoState, getUserProfile } from 'selectors';

import './style.scss';
import validate from './validate';
import asyncValidate from './asyncValidate';

class ReferralForm extends Component {

  constructor() {
    super();

    this.handleInfoBarClose = this.handleInfoBarClose.bind(this);
  }

  componentDidMount() {
    if (this.props.onDidMount) {
      this.props.onDidMount();
    }
  }

  handleInfoBarClose() {
    if(this.props.onInfoBarClose) {
      this.props.onInfoBarClose();
    }
  }

  render() {
    return (
      <div className="ReferralForm">
        {this.props.isSuccessInfoBarVisible && <InfoBar onClose={this.handleInfoBarClose} type="primary" message={this.props.successInfoBarMessage} />}

        <form onSubmit={this.props.handleSubmit}>
          {this.props.provider && <ReferralFormProviderList {...this.props.provider} />}

          <h3>{__('members.faceToFace.form.aboutTitle')}</h3>

          <div className="form-field-wrapper">
            <div className="small-fields full-small-down">
              <div className="option-small">
                <Field
                  name="firstName"
                  label={__('members.faceToFace.form.firstName')}
                  type="text"
                  component={ReferralFormField}
                  isRequired
                />
              </div>
              <div className="option-small">
                <Field
                  name="lastName"
                  label={__('members.faceToFace.form.lastName')}
                  type="text"
                  component={ReferralFormField}
                  isRequired
                />
              </div>
            </div>
          </div>

          <div className="form-field-wrapper">
            <div className="small-fields full-small-down">
              <div className="option-small">
                <Field
                  name="emailAddress"
                  label={__('members.faceToFace.form.emailAddress')}
                  type="email"
                  component={ReferralFormField}
                  isRequired
                />
              </div>
              <div className="option-small">
                <Field
                  name="emailAddressConfirm"
                  label={__('members.faceToFace.form.emailAddressConfirm')}
                  type="email"
                  component={ReferralFormField}
                  isRequired
                />
              </div>
            </div>
          </div>

          <div className="form-field-wrapper">
            <Field
              name="telephone"
              label={__('members.faceToFace.form.telephone')}
              type="tel"
              component={ReferralFormField}
            />
          </div>

          <div className="form-field-wrapper">
            <Field
              name="address"
              label={__('members.faceToFace.form.address')}
              type="text"
              component={ReferralFormField}
            />
          </div>

          <div className="form-field-wrapper">
            <div className="small-fields full-small-down">
              <div className="option-small">
                <Field
                  name="townCity"
                  label={__('members.faceToFace.form.townCity')}
                  component={ReferralFormSelect}
                  normalize={value => parseInt(value, 10)}
                  isRequired
                  entities={this.props.locations}
                  entityKey="location"
                />
              </div>
              <div className="option-small">
                <Field
                  name="postcode"
                  label={__('members.faceToFace.form.postcode')}
                  type="text"
                  isRequired
                  component={ReferralFormField}
                />
              </div>
            </div>
          </div>

          <div className="form-field-wrapper">
            <div className="small-fields full-small-down">
              <div className="option-small">
                <Field
                  name="dob"
                  label={__('members.faceToFace.form.dateOfBirth')}
                  type="date"
                  isRequired
                  component={ReferralFormDatepicker}
                  dateFormat="YYYY-MM-DD"
                  normalize={value => moment(value).format('YYYY-MM-DD')}
                />
              </div>
              <div className="option-small">
                <Field
                  name="preferredLanguage"
                  label={__('members.faceToFace.form.preferredLanguage')}
                  component={ReferralFormSelect}
                  normalize={value => parseInt(value, 10)}
                  isRequired
                  entities={this.props.languages}
                  entityKey="language"
                />
              </div>
            </div>
          </div>

          <h3>{__('members.faceToFace.form.moreAboutTitle')}</h3>

          <div className="form-field-wrapper">
            <Field
              name="school"
              label={__('members.faceToFace.form.school')}
              component={ReferralFormSelect}
              normalize={value => parseInt(value, 10)}
              isRequired
              entities={this.props.schools}
              entityKey="school"
            />
          </div>

          <div className="form-field-wrapper">
            <Field
              name="contactBy"
              label={__('members.faceToFace.form.contactBy')}
              isRequired
              requiredLabel={__('members.faceToFace.form.contactByRequiredLabel')}
              component={ReferralFormCheckboxGroup}
              options={[
                { title: __('members.faceToFace.form.contactByPhone'), name: "phone" },
                { title: __('members.faceToFace.form.contactByEmail'), name: "email" },
                { title: __('members.faceToFace.form.contactByLetterSchool'), name: "letterSchool" },
                { title: __('members.faceToFace.form.contactBySms'), name: "sms" },
                { title: __('members.faceToFace.form.contactByLetterHome'), name: "letterHome" }
              ]}
            />
          </div>

          <div className="form-field-wrapper">
            <Field
              name="childProtection"
              label={__('members.faceToFace.form.childProtection')}
              component={ReferralFormRadioGroup}
              isRequired
              options={[
                { title: __('members.faceToFace.form.radioGroup.yes'), value: "Y" },
                { title: __('members.faceToFace.form.radioGroup.no'), value: "N" },
                { title: __('members.faceToFace.form.radioGroup.dontKnow'), value: "U" }
              ]}
            />
          </div>
          {this.props.childProtectionMoreVisible &&
            <div className="form-field-wrapper">
              <Field
                name="childProtectionMore"
                label={__('members.faceToFace.form.childProtectionMore')}
                component={ReferralFormTextarea}
              />
            </div>
          }

          <div className="form-field-wrapper">
            <Field
              name="additionalNeeds"
              label={__('members.faceToFace.form.additionalNeeds')}
              component={ReferralFormRadioGroup}
              isRequired
              options={[
                { title: __('members.faceToFace.form.radioGroup.yes'), value: "Y" },
                { title: __('members.faceToFace.form.radioGroup.no'), value: "N" },
                { title: __('members.faceToFace.form.radioGroup.dontKnow'), value: "U" }
              ]}
            />
          </div>
          {this.props.additionalNeedsMoreVisible &&
            <div className="form-field-wrapper">
              <Field
                name="additionalNeedsMore"
                label={__('members.faceToFace.form.additionalNeedsMore')}
                component={ReferralFormTextarea}
              />
            </div>
          }

          <div className="form-field-wrapper">
            <Field
              name="legalProceedings"
              label={__('members.faceToFace.form.legalProceedings')}
              component={ReferralFormRadioGroup}
              isRequired
              options={[
                { title: __('members.faceToFace.form.radioGroup.yes'), value: "Y" },
                { title: __('members.faceToFace.form.radioGroup.no'), value: "N" },
                { title: __('members.faceToFace.form.radioGroup.dontKnow'), value: "U" }
              ]}
            />
          </div>
          {this.props.legalProceedingsMoreVisible &&
            <div className="form-field-wrapper">
              <Field
                name="legalProceedingsMore"
                label={__('members.faceToFace.form.legalProceedingsMore')}
                component={ReferralFormTextarea}
              />
            </div>
          }

          <h3>{__('members.faceToFace.form.doctorTitle')}</h3>

          <div className="form-field-wrapper">
            <Field
              name="gpName"
              label={__('members.faceToFace.form.gpName')}
              type="text"
              component={ReferralFormField}
            />
          </div>

          <div className="form-field-wrapper">
            <Field
              name="gpAddress"
              label={__('members.faceToFace.form.gpAddress')}
              type="text"
              component={ReferralFormField}
            />
          </div>

          <h3>{__('members.faceToFace.form.counsellingTitle')}</h3>

          <div className="form-field-wrapper">
            <Field
              name="preferredLocation"
              label={__('members.faceToFace.form.preferredLocation')}
              component={ReferralFormSelect}
              normalize={value => parseInt(value, 10)}
              isRequired
              entities={this.props.schools}
              entityKey="school"
            />
          </div>

          <div className="form-field-wrapper">
            <Field
              name="preferredGender"
              component={ReferralFormSelect}
              label={`Preferred gender of counsellor
(we try to accommodate this but no guarantees)`}
              entities={[
                {id: "U", gender: __('members.faceToFace.form.gender.noPreference')},
                {id: "M", gender: __('members.faceToFace.form.gender.male')},
                {id: "F", gender: __('members.faceToFace.form.gender.female')}
              ]}
              entityKey="gender"
            />
          </div>

          <div className="form-field-wrapper">
            <Field
              name="referralReason"
              label={__('members.faceToFace.form.referralReason')}
              component={ReferralFormTextarea}
            />
            <p className="help-text">
              {__('members.faceToFace.form.referralReasonHelp')}
            </p>
          </div>

          <div className="form-field-wrapper">
            <Field
              name="otherWorkers"
              label={__('members.faceToFace.form.otherWorkers')}
              component={ReferralFormTextarea}
            />
            <p className="help-text">
              {__('members.faceToFace.form.otherWorkersHelp')}
            </p>
          </div>

          <div className="form-field-wrapper">
            <Field
              name="contactWorkers"
              label={__('members.faceToFace.form.contactWorkers')}
              component={ReferralFormRadioGroup}
              format={value => {
                if (value === true) return 'true';
                if (value === false) return 'false';
                return value;
              }}
              normalize={value => {
                if (value === 'true') return true;
                if (value === 'false') return false;
                return value;
              }}
              options={[
                { title: __('members.faceToFace.form.radioGroup.yes'), value: 'true' },
                { title: __('members.faceToFace.form.radioGroup.no'), value: 'false' }
              ]}
            />
          </div>

          {!!this.props.error &&
          <div className="form-wrapper-error-be alert callout">
            <p>{this.props.error}</p>
          </div>}

          <Button
            isYellow
            hasIcon={this.props.submitting}
            isDisabled={this.props.submitting}
            iconType="preloader-dark"
            onClick={this.props.handleSubmit}
          >
            {__('members.faceToFace.form.button')}
          </Button>
          <input type="submit" hidden />
        </form>
      </div>
    );
  }
}

ReferralForm.propTypes = {
  invalid: PropTypes.bool,
  submitting: PropTypes.bool,
  error: PropTypes.string,
  handleSubmit: PropTypes.func,
  onDidMount: PropTypes.func,
  onSubmit: PropTypes.func,
  locations: PropTypes.arrayOf(ReferralLocationShape),
  schools: PropTypes.arrayOf(ReferralSchoolShape),
  languages: PropTypes.arrayOf(ReferralLanguageShape),
  provider: ReferralProvider,
  childProtectionMoreVisible: PropTypes.bool,
  additionalNeedsMoreVisible: PropTypes.bool,
  legalProceedingsMoreVisible: PropTypes.bool,
  isSuccessInfoBarVisible: PropTypes.bool,
  successInfoBarMessage: PropTypes.string,
  onInfoBarClose: PropTypes.func
};

const selector = formValueSelector('referral');
const mapStateToProps = (state) => {
  const childProtectionMoreVisible = selector(state, 'childProtection') === "Y";
  const additionalNeedsMoreVisible = selector(state, 'additionalNeeds') === "Y";
  const legalProceedingsMoreVisible = selector(state, 'legalProceedings') === "Y";

  // currently there is only one provider per area
  const provider = getF2F(state).services[0];

  const successState = getInfoState(state, 'success');
  const isSuccessInfoBarVisible = successState.visible;
  const successInfoBarMessage = successState.message;

  const initialValues = {
    referee: getUserProfile(state).id,
    f2fProvider: provider.id,
    contactBy: {
      email: false,
      sms: false,
      phone: false,
      letterHome: false,
      letterSchool: false
    },
    preferredGender: 'U'
  };

  return {
    initialValues,
    provider,
    ...getF2F(state),
    childProtectionMoreVisible,
    additionalNeedsMoreVisible,
    legalProceedingsMoreVisible,
    isSuccessInfoBarVisible,
    successInfoBarMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onDidMount: () => {
      dispatch(actions.f2fStatusFetch());
      dispatch(actions.f2fLanguagesFetch());
      dispatch(actions.f2fLocationsFetch());
      dispatch(actions.f2fSchoolsFetch());
    },
    onInfoBarClose: () => {
      dispatch(actions.infoClose('success'));
    },
    onSubmit: data => {
      return new Promise((resolve, reject) => {
        dispatch(actions.f2fReferralCreate(data, resolve, reject, __('members.faceToFace.successMessage')));
      });
    }
  };
};


ReferralForm = reduxForm({ //eslint-disable-line no-class-assign
  form: 'referral',
  validate,
  asyncValidate,
  asyncBlurFields: ['telephone', 'dob', 'postcode']
})(ReferralForm);


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReferralForm);




/** WEBPACK FOOTER **
 ** ./src/members/Main/Referral/ReferralForm/index.js
 **/